import { Decimal } from 'decimal.js';
import { InvalidDecimalError } from './errors';

/**
 * ⚠️ กฎเหล็กของโปรเจกต์ (spec Section 5.1)
 * ห้ามใช้ JavaScript number กับเงินหรือจำนวนหน่วย — ผ่านไฟล์นี้เท่านั้น
 *
 * precision 40 หลักสำคัญ เหลือเฟือสำหรับพอร์ตส่วนบุคคล:
 * มูลค่าหลักสิบล้านบาท คูณกับ quantity ที่มีทศนิยม 18 ตำแหน่ง ยังไม่ชนเพดาน
 */
Decimal.set({ precision: 40, rounding: Decimal.ROUND_HALF_UP });

/** ไม่รับ exponent notation, ไม่รับ NaN/Infinity, ไม่รับ string ว่าง */
const DECIMAL_STRING_RE = /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/;

export function isDecimalString(value: unknown): value is string {
  return typeof value === 'string' && DECIMAL_STRING_RE.test(value);
}

/** แปลง decimal string → Decimal (throw ถ้ารูปแบบไม่ถูกต้อง) */
export function toDecimal(value: string, field = 'value'): Decimal {
  if (!isDecimalString(value)) {
    throw new InvalidDecimalError(field, value);
  }
  return new Decimal(value);
}

/**
 * Decimal → decimal string เต็มความละเอียด
 * ใช้ `toFixed()` ไม่ใช่ `toString()` เพราะ toString อาจคืน exponent notation
 * ซึ่งจะทำให้ค่าที่เขียนกลับลง Firestore อ่านซ้ำไม่ผ่าน regex
 */
export function fromDecimal(value: Decimal): string {
  return value.toFixed();
}

/** ปัดเป็นทศนิยม dp ตำแหน่งแล้วคืนเป็น string (ใช้ตอนแสดงผล) */
export function roundTo(value: Decimal, dp: number): string {
  return value.toDecimalPlaces(dp, Decimal.ROUND_HALF_UP).toFixed(dp);
}

export { Decimal };
